import AUTH_API from '@services/auth.service';
import {
  IGetHintAddOnDetailReq,
  IGetHintAddOnDetailRes,
  IRequestHintAddOnPaymentReq,
  IRequestHintAddOnPaymentRes,
  IUpdateRenewalHintAddOnReq,
} from '@models/interfaces/hint.interfaces';
import { IDefaultResponse } from '@models/interfaces/global.interface';
import convertToFormData from '@utils/helpers/convertToFormData';

export async function getHintAddOnDetail(params: IGetHintAddOnDetailReq) {
  return await AUTH_API.post<IGetHintAddOnDetailRes>(
    'subscription/get_hints_add_on_detail/json',
    convertToFormData(params),
  );
}

export async function requestHintAddOnPayment(
  params: IRequestHintAddOnPaymentReq,
) {
  return await AUTH_API.post<IRequestHintAddOnPaymentRes>(
    'subscription/request_hints_add_on_payment_link/json',
    convertToFormData(params),
  );
}

export async function updateRenewalHintAddOn(
  params: IUpdateRenewalHintAddOnReq,
) {
  return await AUTH_API.post<IDefaultResponse>(
    'subscription/update_renewal_hints_add_on/json',
    convertToFormData(params),
  );
}
